import AddRunningRecord from './AddRunningRecord';

export default AddRunningRecord;
